import React, { Component } from 'react'
import './Covid19.css';
import LayoutWrapper from '../../component/LayoutWrapper/'
import Footer from '../../component/Footer/Footer';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class Covid19 extends Component {
    constructor(props){
        super(props);
        this.state={
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    render() {
        return (
            <React.Fragment>
                <LayoutWrapper />

                <main className="main main-container">

                    <nav aria-label="breadcrumb" className="breadcrumb-nav">
                        <div className="container">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Covid-19</li>
                            </ol>
                        </div>
                        {/* End .container */}
                    </nav>
                    <div className="item">
                        <h2>COVID-19</h2>
                    </div>
                    <div className="elementor-text-editor elementor-clearfix cvd-19">
                        <h3 className="ff">YOUR WELLBEING IS OUR #1 PRIORITY.&nbsp;</h3>
                        <p className="ff">
                            <span style={{"fontWeight": "400"}}>
                                We understand the evolving spread of the Coronavirus (COVID-19) in India has caused great concern for the well-being of our greater community. 
                                Our team is working hard to fulfill and ship your orders as soon as possible.&nbsp;
                            </span>
                        </p >
                        <p className="ff">
                            <span style={{"fontWeight": "400"}}>
                                We care about you more than anything, 
                                please stay safe and healthy.
                            </span>
                        </p>
                        <p className="ff">
                            <span style={{"fontWeight": "400"}}>
                                Thank you for being a part of the StyleCabbie family.
                            </span>
                        </p>
                    </div>

                </main>

                <Footer />

            </React.Fragment>
        )
    }
}
export default  Covid19 
